// extracted by mini-css-extract-plugin
export default {"root":"DomainList-root_aBWlb","buttonContainer":"DomainList-buttonContainer_GdnVf","button":"DomainList-button_PJKR6"};